import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  LONG_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";
import { VehicleOptions } from "../../types/Vehicles";

export const getVehicleOptions = (
  variantId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["vehicle-options", variantId],
    queryFn: (): Promise<VehicleOptions> => {
      return fetchWithAuth<VehicleOptions>("getVehicleOptions", variantId);
    },
    enabled: isQueryEnabled(options),
    staleTime: LONG_STALE_TIME,
  });
};
